import React from 'react';
import { Field } from 'react-final-form';
import { Form } from 'react-bootstrap';

//Components
import { campotexto } from '../campos/campos';

//TOOLS
import { getTraducaoTrocaPor as trad } from '../../../utils/getTraducoes';

class FormLogin extends React.Component {
    
    render(){
        return (            
            <Form.Row>
                <Field type='text' name='email' label='E-mail' component={campotexto} />
                <Field type='password' name='senha' label={trad(this.props.trads,'CONF_SENHA',this.props.lingua)} component={campotexto} />                
            </Form.Row>            
        )
    }
}

export default FormLogin;